import React from "react";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import "./AboutUs.css";

function AboutUs(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

    const SCREEN_TEXT = {
      highlights: {
        /* bullets: [
                "Štedimo vaše vrijeme",
                "Štedimo vaš novac",
                "Podižemo kvalitet vašeg rada",
                "Podižemo vaš rejting"
            ], */
        bullets: [
          `Mi smo privredno društvo posvećeno pružanju sveobuhvatne podrške fizičkim i pravnim licima. 
          Naš tim čine iskusni pravnici, IT inženjeri i marketing stručnjaci,
          spremni da vam pomognu u ključnim poslovnim procesima.`,
          `Sarađujemo i sa stručnjacima iz raznih drugih oblasti, čime vam omogućavamo kompletna rješenja na jednom mjestu. 
          Naš cilj je da vi ne brinete o pravnim pitanjima, zaštiti ličnih podataka i digitalnom prisustvu, 
          već da se fokusirate na razvoj svog posla.`,
          `Oslonite se na nas za sve, od registracije samostalnog preduzetništva ili poslovnog subjekta,
          usklađivanja sa Zakonom o zaštiti ličnih podataka,
           izrade internih pravnih dokumenata i ugovora,
           preko marketing strategija i vođenja društvenih mreža,
           do razvoja web stranica.
          `,
          `Sa nama dobijate sigurnost, efikasnost i profesionalnu podršku u svakom koraku. `
        ],
        heading: "Neki od razloga za saradnju: ",
      },
    };

    const renderHighlights = () => {
        return (
          SCREEN_TEXT.highlights.bullets.map((value, i) => (
          <div className="highlight" key={i}>
            <div className="highlight-blob"></div>
              <span>{value}</span>
          </div>
        ))
      )
      };


  return (
    //ne radi još scroll jer nemaš class ili id screena. Radi kad si dodao classe i id
    <div
      className="about-us-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-us-parent">
        <ScreenHeading title="O nama" subHeading="Zašto izabrati nas?" />
        <div className="about-us-card"> 
          <div className="about-us-logo"></div>
          <div className="about-us-text"> 
            {" "}
            <div className="about-us-highlights">
                {renderHighlights()}
            </div>
            <div className="about-us-options">
            <button className="btn about-btn" 
            onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {""}
              Kontakt{" "}
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
